//Built-In
import React, {Fragment} from 'react';
//External

//Internal
import Common from "../../Common/Common";
import CommonHeaderContent from "../../Common/CommonHeaderContent";
import {convertUTCToLocalTime, getConnectionStatus, loadCustomFormData, setSessionValue, showToast} from "../../Common/Appcommon";
import ListTable from "../../Common/ListTable";
import {statusSearchOptions} from "./Constants";
import CratioTooltip from "../../Common/CratioTooltip";
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";

class Automations extends React.Component {
    formname = process.env.REACT_APP_AUTOMATION_FORMNAME;
    hasMore = false;
    constructor(props) {
        super(props);
        let defaultSearched = {};
        let defaultFilterTxt = '';
        if(statusSearchOptions !== undefined && statusSearchOptions[1].value !== undefined){
            defaultSearched = {"advanced_search_key":"nondate@"+this.formname+"@Status@is@"+statusSearchOptions[1].value+"@AND#","STARTC":"true"}
            defaultFilterTxt = "nondate@"+this.formname+"@Status@is@"+statusSearchOptions[1].value+"@OR#";
            defaultFilterTxt += "nondate@"+this.formname+"@Status@is@"+statusSearchOptions[2].value+"@OR#";
        }
        this.state = {
            formData : [],
            showLoader : false,
            listFields : [],
            page:1,
            limit:50,
            searchTxt:[],
            filterTxt: defaultFilterTxt,
            totalCount : 200,
            advancedSearch: defaultSearched,
            otherInfo : [],
            selectOption : statusSearchOptions[1].value
        }
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        let response = await getConnectionStatus();
        let connection = "";
        if(response.issuccess) {
            let data = response.data;
            connection = data['connection'];
        }
        await this.loadAutomationFormData();
        this.setState({
            showLoader : false,
            connectionStatus : connection
        })
        setSessionValue('validCampaignsIds', []);
    };

    loadAutomationFormData = async (showLoader = false,skipAppending=false,resetPagination = false) => {
        if(showLoader) {
            this.setState({
                showLoader: true
            })
        }
        let page = this.state.page;
        if(resetPagination){
            this.setState({page:1});
            page = 1;
            this.hasMore = true;
        }
        const { rowData , listFields, totalCount, otherInfo } =
            await loadCustomFormData(
                true,
                this.formname,
                this.state,
                true
            );
        this.setState({
            formData: skipAppending ? rowData : [...this.state.formData, ...rowData],
            listFields: listFields,
            totalCount: totalCount,
            showLoader: false,
            otherInfo : otherInfo
        })
    }

    openNewAutomation = async(e)=>{
        window.location.href = "#/automation/new";
    }

    initiateEditAutomation = async(e, campaignId) => {
        window.location.href = "#/automation/edit/"+campaignId;
    }

    searchChangeHandler = async(e) => {
        let {filterTxt, searchTxt} = this.state;
        let filterVal = e.value;
        let searchCondition = "";
        if(filterVal !== undefined){
            if(filterVal === "All"){
                searchCondition = "nondate@"+this.formname+"@Status@is@Active@OR#";
                searchCondition += "nondate@"+this.formname+"@Status@is@Inactive@AND#";
            }else if(filterVal !== undefined && filterVal !== ''){
                searchCondition = "nondate@"+this.formname+"@Status@is@"+filterVal+"@AND#";
            }
            filterTxt = searchCondition;
        }else{
            filterVal = e.target.value;
            searchCondition = "nondate@"+this.formname+"@Name@contains@"+filterVal+"@AND#";

            searchTxt = searchCondition;
        }
        let advancedSearch = {
            advanced_search_key :filterTxt+searchTxt,
            STARTC : "true"
        }
        await this.setState({
            advancedSearch : advancedSearch,
            filterTxt,
            searchTxt,
            selectOption : filterVal
        });
        await this.loadAutomationFormData(true, true);
    }

    deleteCallBack = () => {
        showToast("Deleted Successfully!",'top-right','success');
        this.loadAutomationFormData(true, true);
    }

    renderElements = (name,formData,fields,childprops,childstate) => {

        if(name === 'statusBadge'){
            let fieldvalue = formData['Status'];
            let bclass = 'bg-success';
            if(fieldvalue == 'Active'){
                bclass = 'bg-success';
            } else if (fieldvalue == 'Inactive'){
                bclass = 'bg-info';
            }
            return (
                <>
                    <div className={`ml-1 badge rounded-pill ${bclass}`}>
                        {fieldvalue}
                    </div>
                </>
            )
        } else if (name === "peopleData"){
            let autoId = formData[this.formname+"_id"];
            let activeCount = 0;
            let completedCount = 0;
            let auditInfo = this.state.otherInfo;
            if(auditInfo[autoId] !== undefined){
                activeCount = auditInfo[autoId]['Active'];
                completedCount = auditInfo[autoId]['Completed'];
            }
            return (
                <>
                    <div className={`d-grid`}>
                        <span>{activeCount} Active</span>
                        <span>{completedCount} Completed</span>
                    </div>
                </>
            )
        } else if (name === "nameInfo"){
            let fieldvalue = formData['Name'];
            let createdBy = formData['Created Username'];
            let updatedOn = formData['updatedon'];
            if(updatedOn !== ""){
                updatedOn = convertUTCToLocalTime(updatedOn);
            }
            let tooltiptxt = "Last Updated User/ Time";
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{fieldvalue}</span>
                        <CratioTooltip title={tooltiptxt} content={<span className={'template-secondary'}>{createdBy}, {updatedOn}</span>} />
                    </div>
                </>
            )
        }
    }

    render(){
        let {formData, selectOption} = this.state;
        let fields = this.state.listFields;
        if(this.state.listFields === undefined){
            return <></>
        }
        let customRowConfig = {
            link : {
                onClick : this.initiateEditAutomation,
                condition : "",
                class : "row-link"
            }
        }
        let headerFieldConfig = {
            Name : {
                "class" : "text-left w-1"
            },
            "NO OF MESSAGES" : {
                "class" : "w-5"
            },
            "PEOPLE IN AUTOMATION" : {
                "class" : "w-5"
            },
            Status : {
                "class" : "w-5"
            }
        };
        let customFieldConfig = {
            Status:{
                "render" : "statusBadge"
            },
            Name:{
                "class" : "text-left",
                "render" : "nameInfo"
            },
            people : {
                "render" : "peopleData"
            },
            createdon : {
                toLocalDate : true
            }
        };
        let connectionStatus = this.state.connectionStatus;
        let connectMsg = "";
        if(connectionStatus === ""){
            connectMsg = "You have to connect Cloud API to Create Automation";
        }/* else if (connectionStatus === "sandbox"){
            connectMsg = "You are connected in Sandbox mode connect your own number with Whatsapp Cloud API.";
        }*/
        return (
            <Common pageTitle={"Automation"} showLoader={this.state.showLoader} mainContent={
                <Fragment>
                    <CommonHeaderContent
                        isStatusFilter={true}
                        isSearchBox={true}
                        buttonAction={this.openNewAutomation}
                        searchChangeHandler={this.searchChangeHandler}
                        searchChangeNameHandler={this.searchChangeHandler}
                        buttonIcon={faCirclePlus}
                        prefix={'automations'}
                        headerTitle={'Automation'}
                        buttonTxt={'New Automation'}
                        headerMsg={connectMsg}
                        defaultSelect={statusSearchOptions[1]}
                        selectOptions={statusSearchOptions}
                        mainContent={
                            <div className={'main-card mb-3 card mh-350'}>
                                <div className={'card-body'}>
                                    <ListTable
                                        key={Math.random()}
                                        formData={formData}
                                        fields={fields}
                                        showRowCount={true}
                                        customRowConfig={customRowConfig}
                                        config={customFieldConfig}
                                        renderElements={this.renderElements}
                                        formName={this.formname}
                                        isDeleteNeeded={selectOption === "Inactive"}
                                        deleteCallBack={this.deleteCallBack}
                                        viewNeeded={false}
                                        prefix={'automations'}
                                        analyticsNeeded={true}
                                        accordianName={'automation-analytics'}
                                        customClass={'no-border-table'}
                                        headerConfig={headerFieldConfig}
                                        defaultaccordianStatus = {false}
                                    />
                                </div>

                            </div>

                        } />
                </Fragment>
            } />
        )
    }

}

export default Automations;